import React from 'react';
import '../Forms/Multistep/multistep.css';
import LegalDocument from './LegalDocument';

const PrivacyPolShopify = () => {
  return <LegalDocument documentType="privacy_policy" userType="all" />;
};

export default PrivacyPolShopify;
